<script>
import Multiselect from "@/components/RMultiselect.vue";

import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {Multiselect},
  props: {
    correspondence: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      listPersons: [],
      listFormats: [],
      listTypes: [],
    };
  },
  beforeMount() {
    if (!this.correspondence.date) {
      this.correspondence.date = {
        day: '',
        month: '',
        year: ''
      }
    }

    if (sessionStorage.getItem('persons'))
      this.listPersons = JSON.parse(sessionStorage.getItem('persons'));
    else {
      api.get('persons').then((response) => {
        this.listPersons = response.data.data;
        sessionStorage.setItem('persons', JSON.stringify(this.listPersons));

        return this.listPersons;
      });
    }

    if (sessionStorage.getItem('document_types'))
      this.listFormats = JSON.parse(sessionStorage.getItem('document_types'));
    else {
      api.get('document_types').then((response) => {
        this.listFormats = response.data.data;
        sessionStorage.setItem('document_types', JSON.stringify(this.listFormats));

        return this.listFormats;
      });
    }

    if (sessionStorage.getItem('letter_types'))
      this.listTypes = JSON.parse(sessionStorage.getItem('letter_types'));
    else {
      api.get('letter_types').then((response) => {
        this.listTypes = response.data.data;
        sessionStorage.setItem('letter_types', JSON.stringify(this.listTypes));

        return this.listTypes;
      });
    }
  },
  methods: {
    async submitForm() {
      delete this.correspondence.date.id;

      api.save('correspondences', this.correspondence)
          .then((response) => {
            if (response.status !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
    formatSelectListPersons(person) {
      return `${person.last_name} ${person.first_name}`
    },
  }
};
</script>

<template>

  <b-form>
    <b-card no-body class="mb-2 pt-2">
      <b-card-body class="p-0">
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Sujet" label-for="formrow-subject-input">
              <b-form-input id="formrow-subject-input" type="text"
                            v-model="correspondence.subject"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>


        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Expéditeur" label-for="formrow-author-input">
              <multiselect
                  id="formrow-author-input"
                  v-model="correspondence.author"
                  :options="listPersons"
                  label="last_name"
                  track-by="id"
                  select-label=""
                  :custom-label="formatSelectListPersons"
                  :show-labels="false"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Destinataire" label-for="formrow-recipient-input">
              <multiselect
                  id="formrow-recipient-input"
                  v-model="correspondence.recipient"
                  :options="listPersons"
                  label="last_name"
                  track-by="id"
                  select-label=""
                  :custom-label="formatSelectListPersons"
                  :show-labels="false"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Adresse expédition" label-for="formrow-location_departure-input">
              <b-form-input id="formrow-location_departure-input" type="text"
                            v-model="correspondence.location_departure"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Adresse destinataire" label-for="formrow-location_destination-input">
              <b-form-input id="formrow-location_destination-input" type="text"
                            v-model="correspondence.location_destination"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Format" label-for="formrow-format-input">
              <multiselect
                  id="formrow-format-input"
                  v-model="correspondence.document_type"
                  :options="listFormats"
                  label="name"
                  track-by="id"
                  select-label=""
                  :show-labels="false"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Type" label-for="formrow-letter_type-input">
              <multiselect
                  id="formrow-letter_type-input"
                  v-model="correspondence.letter_type"
                  :options="listTypes"
                  label="name"
                  track-by="id"
                  select-label=""
                  :show-labels="false"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Type script" label-for="formrow-typescript_manuscript-input">
              <select id="formrow-typescript_manuscript-input"
                      class="form-control"
                      v-model="correspondence.typescript_manuscript">
                <option value=""></option>
                <option value="manuscript">manuscript</option>
                <option value="typescript">typescript</option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Jour" label-for="formrow-jour-input">
              <b-form-input id="formrow-jour-input" type="number" min="1" max="31"
                            v-model="correspondence.date.day"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Mois" label-for="formrow-mois-input">
              <b-form-input id="formrow-mois-input" type="number" min="1" max="12"
                            v-model="correspondence.date.month"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Année" label-for="formrow-annee-input">
              <b-form-input id="formrow-annee-input" type="number" min="1"
                            v-model="correspondence.date.year"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Personnalités associées" label-for="formrow-personnes-input">
              <multiselect
                  id="formrow-personnes-input"
                  v-model="correspondence.persons"
                  :options="listPersons"
                  label="last_name"
                  track-by="id"
                  select-label=""
                  :multiple="true"
                  :custom-label="formatSelectListPersons"
                  :show-labels="false"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col md="8">
            <b-form-group label="Pièce jointe" label-for="formrow-attachment-input">
              <b-form-input id="formrow-attachment-input" type="text"
                            v-model="correspondence.attachment"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Nombre de page" label-for="formrow-page_quantity-input">
              <b-form-input id="formrow-page_quantity-input" type="number" min="1"
                            v-model="correspondence.page_quantity"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Commentaire" label-for="formrow-comment-input">
              <b-form-textarea id="formrow-comment-input"
                               v-model="correspondence.comment"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>


    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>